"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynaRamDisk_1 = require("./DynaRamDisk");
var memory = new DynaRamDisk_1.DynaRamDisk();
var guid = 0;
exports.createRam = function (containerName) {
    if (containerName === void 0) { containerName = 'c'; }
    var containerPrefix = "dmem-" + guid++ + "--";
    return {
        set: function (key, data) { return memory.set(containerPrefix + containerName, key, data); },
        get: function (key) { return memory.get(containerPrefix + containerName, key); },
        del: function (key) { return memory.del(containerPrefix + containerName, key); },
        delAll: function () { return memory.delContainer(containerPrefix + containerName); },
    };
};
//# sourceMappingURL=createRam.js.map